import React from 'react';
import Paper from '@material-ui/core/Paper';
import { curry, } from 'ramda';

import { makePaperStyles } from 'styles/components/paper';
import { DEFAULT_PAPER_ELEVATION, } from 'common/constants';

type WrappedComponentProps<T> = {
    [key: string]: T;
};

const WithPaper = curry(
    (hocProps: any, WrappedComponent: React.ElementType, props: WrappedComponentProps<unknown>) => {
        const noPadding = { hocProps };
        const paperClasses = makePaperStyles();
        const padding = noPadding && paperClasses.noPadding;

        return (
            <Paper classes={paperClasses} className={padding} elevation={DEFAULT_PAPER_ELEVATION} square>
                <WrappedComponent {...props} />
            </Paper>
        );
    },
);

export default WithPaper;
